export default __webpack_public_path__ + "static/media/TWSL - DRUM_1.1dd2db5d.wav";